const KEYS = {
  idToken: 'car-ia:idToken',
  refreshToken: 'car-ia:refreshToken',
  expiry: 'car-ia:tokenExpiry', // epoch ms when idToken expires
};

export function saveTokens({
  idToken,
  refreshToken,
  expiresIn,
}: {
  idToken: string;
  refreshToken: string;
  expiresIn: number;
}): void {
  localStorage.setItem(KEYS.idToken, idToken);
  localStorage.setItem(KEYS.refreshToken, refreshToken);
  localStorage.setItem(KEYS.expiry, String(Date.now() + expiresIn * 1000));
}

export function getStoredTokens(): {
  idToken: string | null;
  refreshToken: string | null;
  expiry: number | null;
} {
  return {
    idToken: localStorage.getItem(KEYS.idToken),
    refreshToken: localStorage.getItem(KEYS.refreshToken),
    expiry: (() => {
      const raw = localStorage.getItem(KEYS.expiry);
      return raw ? Number(raw) : null;
    })(),
  };
}

export function clearTokens(): void {
  Object.values(KEYS).forEach((key) => localStorage.removeItem(key));
}

export function isTokenExpired(idToken: string): boolean {
  try {
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    // Add a 30-second buffer to account for clock skew
    return payload.exp * 1000 < Date.now() + 30_000;
  } catch {
    return true;
  }
}

export function decodeIdToken(idToken: string): Record<string, any> | null {
  try {
    return JSON.parse(atob(idToken.split('.')[1]));
  } catch {
    return null;
  }
}
